import { createContext, useState } from "react";


//GA4
import ReactGA from 'react-ga4';
const TRACKING_ID = "G-2DE9787T5P"; // YOUR_OWN_TRACKING_ID
ReactGA.initialize(TRACKING_ID);

export const GeneralContext = createContext({
    userInfo: {},
    loading: true,
    changeUserInfo: () => {},
    getTitle: () => {},
    getDesc: () => {},
    setLoading: () => {}
});

export const GeneralProvider = ({children}) => {
    /*var location = useLocation();
    useEffect(()=>{
        ReactGA.send({ hitType: "pageview", page: location.pathname, title: document.title + " manual" });
        console.log(location);
    }, [location])*/
    const [userInfo, setUserInfo] = useState({});
    const [loading, setLoading] = useState(false);
    const changeUserInfo = (newUserInfo) =>{
        setUserInfo({...userInfo,...newUserInfo});
    }

    const getTitle = (page) =>{
        
    }

    const getDesc = (page) =>{
        
    }

    const value = {
        userInfo, 
        loading,
        changeUserInfo,
        getTitle,
        getDesc,
        setLoading
};

    return <GeneralContext.Provider value={value}>
                <div className="loading-placeholder" style={{display:(loading?"block":"none")}}>
                    <div>
                        <i className="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i>
                    </div>
                </div>
                {children}
            </GeneralContext.Provider>
}